import React from 'react';
import { FiFacebook, FiMail, FiMapPin, FiPhone } from 'react-icons/fi';
import { Container } from './styles';





const Footer: React.FC = () => {





    return (
        <Container >
            <div >
                <FiPhone className="FIIcon" color='f85d00' size={30} />
                <a href="tel:+556241419084">(62) 4141-9084 &nbsp;</a>
                <a href="tel:+5562981263687">(62) 98126-3687</a>
            </div>
            <div>
                <FiMail className="FIIcon" color='f85d00' size={30} />
                <a href="mailto:contato@estudiocriar.com">contato@estudiocriar.com</a>
            </div>
            <div id="ContainerFIIcon" >
                <FiMapPin className="FIIcon" color='f85d00' size={30} />
                <div id="right">
                    <p>Av. T-63, esq. com Av. T-15 e Rua C-235, Qd. 145, Lts. 08/09 - Edif. New World,</p>
                    <div id="footer">
                        <p>Sl. 1110 St. Bueno - Goiânia – GO - CEP: 74230-100</p>
                        <a href="https://www.google.com.br/maps/place/Estudio+Criar+-+Ag%C3%AAncia+Digital./@-16.71407,-49.2729643,17z/data=!3m1!4b1!4m5!3m4!1s0x935ef17a83fdd4d5:0x45d0c1168e64b1e4!8m2!3d-16.71407!4d-49.2707756"
                            className="vermapa" target="blank">VER MAPA
                        </a>
                    </div>

                </div>
            </div>
            <div>
                <a href="https://www.facebook.com/agenciacriar/" target="blank">
                    <FiFacebook className="FIIcon" color='f85d00' size={30} />
                </a>
            </div>

        </Container>
    );
};

export default Footer